module.exports = __webpack_public_path__ + "img/horizontal_3_1_8017.8b6e9ca9.png";